<template>
  <router-view />
</template>

<script>
import { i18n, loadDeviseLocalesFromAPI } from '../../app/i18n';
import eventBus from '../../shared/utils/event-bus';

export default {
  async created() {
    eventBus.on('server-error', () => {
      this.notify(i18n.t('app.oops_server_error_try_again_later'));
    });

    eventBus.on('forbidden-error', (data) => {
      if (data.redirect) {
        this.notify(i18n.t('app.you_are_not_authorized_to_perform_this_action'));
        setTimeout(() => { window.location = data.redirect; }, 1500);
      }
    });

    eventBus.on('not-found-error', () => {
      this.notify(i18n.t('app.oops_not_found_try_again_later'));
    });

    await loadDeviseLocalesFromAPI();
  },
  methods: {
    notify(message) {
      this.$swal(message);
    },
  },
};
</script>
